module.exports = __webpack_public_path__ + "img/mt12.6147c964.jpg";